import { StyleSheet } from 'react-native';
import GStyles from '../../global/styles';

export const placeholderTextColor = '#BEBFBF';
export const backgroundColor = '#ffffff';
export const fieldHeight = 40;
export const borderRadius = 8;
export const textFontSize = GStyles.fontSizeOptions.text;
export const subTextFontSize = GStyles.fontSizeOptions.subtext;
export const titleFontSize = GStyles.fontSizeOptions.title;
export const subTitleFontSize = GStyles.fontSizeOptions.subtitle;

export const fieldBackground = {
    backgroundColor: backgroundColor,
    borderWidth: StyleSheet.hairlineWidth, 
    borderColor:'#DBDBDB',
    borderRadius,
}

export const allStyles = {
    fieldContainer: {
        flexDirection:'column',
        marginVertical:8,
        position:'relative'
    },
    fieldRow: {
        flexDirection:'row',
    },
    title: {
        color: '#212121',
        fontSize: textFontSize,
        fontWeight:'bold',
        marginVertical: 4,
        marginBottom: 8,
    },
    red: {
        fontSize: textFontSize,
        fontWeight:'normal',
        color: '#8B0000',
    },
    tip: {
        fontSize: subTextFontSize,
        fontWeight:'normal',
        color: '#BDBEC4',
    },
    textInput: {
        ...fieldBackground,
        paddingVertical: 8,
        paddingHorizontal: 10,
        fontSize: textFontSize,
        color:'#212121',
        height:fieldHeight,
    }, 
    selectContainer: {
        ...fieldBackground,
        borderWidth: 0,
        color:'#212121',
    },
    placeholderStyle: {
        fontSize: textFontSize,
        color:placeholderTextColor,
    },
    dropDownStyle: {
        ...fieldBackground,
    },
    dropDownLabel: {
        color:'#212121',
        fontSize: textFontSize
    },
    seperator: {
        height:StyleSheet.hairlineWidth, 
        backgroundColor:placeholderTextColor,
    },
    photoContainer: {
        marginVertical: 8,
    },
    photoButton: {
        height: 120,
        width: 120,
        borderRadius,
        backgroundColor:'#F2F2F2',
        alignItems:'center',
        justifyContent:'center',
    },
    photoReview: {
        height: 120,
        width: 120,
        borderRadius,
    },
    addIcon: {
        width:16,
        height:16,
        marginBottom:4,
    },
    barcodeButton: {
        paddingRight:6,
        height:fieldHeight-8,
        marginBottom:4,
        marginRight:4,
        borderRadius,
        backgroundColor:'#212121',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'row',
        position:'absolute',
        bottom:0,
        right:0,
        zIndex:1000,
    },
    barcodeButtonTitle: {
        color:'#FFFFFF',
    },
    barcodeIcon: {
        height:fieldHeight-20,
    },
    countryCodeContainer: {
        flexDirection:'row', 
        alignItems:'center', 
        position:'absolute', 
        bottom:0, 
        left:8, 
        zIndex: 1000, 
        width: 85,
    },
    text: {
        fontSize: textFontSize,
        color:'#212121'
    },
    countryCodeContainerForQuery: {
        width:95, 
        justifyContent:'center', 
        marginRight:14,
    },
    phoneInputForQuery: {
        flex:1, 
        backgroundColor:'transparent', 
        borderColor:'#ACACAC',
        borderWidth:StyleSheet.hairlineWidth,
    },
    modalBackdrop: {
        flex:1, 
        justifyContent:'center', 
        alignItems:'center', 
        backgroundColor:'rgba(0, 0, 0, 0.7)'
    },
    modalContainer: {
        width:'90%', 
        maxHeight:'60%', 
        paddingTop:16, 
        backgroundColor:'white', 
        borderRadius:16
    },
    modalTitle: {
        color:'#212121',
        fontSize: textFontSize,
        textAlign:'center',
        fontWeight:'bold',
    },
    modalSelectItemContainer: {
        borderBottomColor:'#707070',
        borderBottomWidth:StyleSheet.hairlineWidth,
        paddingVertical: 16,
        flexDirection:'row',
        alignItems:'center',
    },
    modalSelectItemBubble: {
        borderRadius:7,
        borderWidth:StyleSheet.hairlineWidth,
        borderColor:'#212121',
        width:14,
        height:14,
        marginRight:8,
    },
    modalSelectItemBubbleSeleted: {
        borderRadius:7,
        backgroundColor:'#212121',
        width:14,
        height:14,
        marginRight:8,
    },
    selectContainer: {
        ...fieldBackground,
        height:fieldHeight,
        alignItems:'center',
        paddingHorizontal: 10,
        flexDirection:'row'
    }, 
    selectText: {
        color:'#212121',
        fontSize: textFontSize
    },
    filledBox: {
        // backgroundColor: '#FFFFFF', 
        // borderWidth: StyleSheet.hairlineWidth, 
        // borderColor:'#212121'
    },
    disabledBox: {
        backgroundColor: '#F2F2F2',
        borderColor:'#DBDBDB',
        color: '#585858',
    }
};
